import Loader from 'react-loader-spinner'
import React from 'react';
import comuniItaliani from './res/comuniItaliani';
import Box from './components/Box';
import './App.css';

const 
  COMUNE = 'comune', 
  CIVICO = 'civico',
  INDIRIZZO = 'indirizzo',
  DEBOUNCETIME = 500;

const loaderType = 'ThreeDots';
let timeout = null;

const isFirefox = () => typeof InstallTrigger !== 'undefined';

export default class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inputIndirizzi:'',
      inputCivici:'',
      loader:'',
      result:'',
      civici:[],
      btnCoverage:'',
      renrIndFlg:'',
      indirizzoDataList:'',
      indirizzi:[],
      searchComuni:'',
      indirizziMapped:[]
    };
  }
 
  componentDidMount() {
    const searchComuni = (
      <div className = 'inputBox'>
        <input 
          id = "comune" 
          type = "text" 
          list = "comuni_list"
          onChange = { this.showIndirizziInpt }
          className = "roundBox" 
          placeholder = "Comune"
          style = {{ textTransform: 'uppercase'}}
        />

        <datalist id = "comuni_list" >
          {
            comuniItaliani.map( 
              (el, k) => <option className = "roundBox" key={k} value={el}> {el} </option> 
            )
          }
        </datalist>
        <br/>
      </div>
    );
    this.setState({searchComuni});
  }

  // Richiede al server i valori per il query obj
  __serverDatalistReq = async (qryObj) => {
    try {
      const req = await fetch(
        'https://olisys.it/coverageChecker',
        //'http://localhost:8123/',
        {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: { 'Content-Type': 'application/json' },
          redirect: 'follow', // manual, *follow, error
          referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify(qryObj) // body data type must match "Content-Type" header
        }
      )
      const value = await req.json()
      return value;
    } catch(e) {
      console.error("Error while fetching:", e);
    }
  }

  // Funzione principale che produce le result box
  getResult = async () => {
    if (!this.__areTheseInputsOk(COMUNE, INDIRIZZO, CIVICO)) { return; }
    this.__showLoader()
    const res = await this.__serverDatalistReq({ 
      comune: this.__getComuneValue(), 
      civico: this.__getCivicoValue(),
      indirizzo: this.__getIndirizzoValue(), 
    });
    this.__cleanView();
    this.__renderBoxes(res)
  }

  __cleanView = () => {
    this.setState({
      searchComuni:'',
      inputIndirizzi:'',
      inputCivici:'',
      btnCoverage:'',
    })
  }

  __compBySpeed = (a, b) => {
    if ( parseInt(a.massima) > parseInt(b.massima) ) { return -1; }
    if ( parseInt(a.massima) < parseInt(b.massima) ) { return 1; }
    return 0;
  }

  __renderBoxes = (response) => {
    this.__clearLoader();
    if (!response.connections) { this.__renderSorry(response); return; }
    
    // Ordina per velocità:
    const connSorted = Object.values(response.connections).sort(this.__compBySpeed);

    this.showResult( <div> 
      <h3 className = 'horizontalLayout widt90marg5'> Servizi disponibili per: <br/> {response.indirizzo_trovato} </h3>
      <div className = 'resultContainer .fullWidth'>
        { connSorted.map(
          (el, k) => <Box key={k} title={el.type} value={el} setResult={this.showResult}/>
        )} 
      </div>
    </div>)
  }

  // renderizza il messaggio in cui si dice non esserci nessun servizio
  __renderSorry = (response) =>{
    this.showResult(
      <div> 
        <h3> 
          Ci dispiace, per il suo indirizzo: <br/>
          {response.indirizzo_trovato}, <br/>
          Non sono stati trovati servizi Wired, 
          la invitiamo a contattarci per verificare la copertura 
          con tecnologia Wireless.
        </h3>
      </div>
    )
  }

  // Renderizza il loader
  __showLoader = () => {
    this.setState({ loader:<Loader type = {loaderType} color = "#286290" /> });
  }

  // rimuove il loader
  __clearLoader = () => { this.setState({ loader:'' }); }

  // renderizza il risultato
  showResult = (result) => this.setState({ result });

  showIndirizziInpt = async() => {
    if (!this.__areTheseInputsOk(COMUNE)) { return; }
    this.__showLoader();

    const 
      indirizzi = ( 
        await this.__serverDatalistReq({ 
          comune: this.__getComuneValue(), 
          indirizzo: '""'
        }) 
      ).indirizzo,
      indirizziMapped = indirizzi.map( (el,k) => <option key={k}> {el} </option> );
    
    this.setState({ indirizzi, indirizziMapped });

    this.setState({
      inputIndirizzi: <div className = 'inputBox'>
      <input 
        id = "indirizzo" 
        list = "indirizzo_list"
        type = 'list'
        autocomplete = { isFirefox() ? 'off': 'on'}
        onChange = { this.srcInputDebouncer }
        className = "roundBox" 
        placeholder = "Indirizzo" 
        style = {{ textTransform: 'uppercase'}}
      />
      <br/>
    </div>
    })
    this.__clearLoader();
  }

  // funzione di debounce per l'input dell'indirizzo
  srcInputDebouncer = () => {
    clearTimeout(timeout);
    timeout = setTimeout(this.__searchAddress, DEBOUNCETIME);
  }

  // Ricerca l'indirizzo
  __searchAddress = async () => {
    if (!this.__areTheseInputsOk(COMUNE)) { return; }
    if ((this.__getIndirizzoValue()).length < 3) { return; }

    const indirizzi = ( 
      await this.__serverDatalistReq({ 
        comune: this.__getComuneValue(), 
        indirizzo: this.__getIndirizzoValue(),
      }) 
    ).indirizzo;
    const indirizziMapped = indirizzi.map( (el,k) => <option key={k}> {el} </option> )
    await this.setState({ indirizzi, indirizziMapped })
    this.__showCivici();
  }

  // Controlla se le variabili sono valorizzate in maniera corretta
  __areTheseInputsOk = (comuneP='', indirizzoP='', civicoP='') => {
    if (comuneP) {
      const comune = this.__getComuneValue();
      if (!comune || !comuniItaliani.includes(comune)) { return false; }
    }
    if (indirizzoP) {
      const indirizzo = this.__getIndirizzoValue();
      if (!indirizzo || !this.state.indirizzi.includes(indirizzo)) { return false; }
    }
    if (civicoP) {
      const civico = this.__getCivicoValue();
      if (!civico || !this.state.civici.includes(civico)) { return false; }
    }
    return true
  }

  // func sinonimo, per maggior pulizia
  __getComuneValue = () => document.getElementById("comune").value
  // func sinonimo, per maggior pulizia
  __getIndirizzoValue = () => document.getElementById("indirizzo").value
  // func sinonimo, per maggior pulizia
  __getCivicoValue = () => document.getElementById("civico").value

  __showCivici = async () => {
    if (!this.__areTheseInputsOk(COMUNE, INDIRIZZO)) { return; }
    this.__showLoader();
    const civici = (
      await this.__serverDatalistReq({ 
        comune: this.__getComuneValue(),
        civico: -1,
        indirizzo: this.__getIndirizzoValue(),
      })
    ).civico;
    this.setState({ civici });
    this.setState({
      inputCivici:<div className = 'inputBox'>
        <input 
          id = "civico" 
          type = "text" 
          list = "civico_list"
          onChange = { this.showBtnCoverage }
          className = "roundBox" 
          placeholder = "Civico" 
          style = {{ textTransform: 'uppercase'}}
        />
        <datalist id = "civico_list">
          { civici.map( (el,k) => <option key = {k} value={el}> {el} </option> ) }
        </datalist>
      </div>
    })
    this.__clearLoader();
  }

  showBtnCoverage = async () => {
    this.setState({
      btnCoverage:<div className='verticalLayout'>
        <br />
        <div onClick = {this.getResult} className="btn btn-secondary"> 
          <h1 style = {{ color:"#fff" }}> Verifica Copertura </h1>
        </div>
      </div>
    })
  }

  render() {
    return (
      <div className="app">
      <header className="App-header">
        <div className='verticalLayout widt90marg5'> 
          {this.state.searchComuni}
          {this.state.inputIndirizzi}
          <datalist id = "indirizzo_list">
            { this.state.indirizziMapped }
          </datalist>
          {this.state.inputCivici}
          {this.state.btnCoverage}
          <div className='horizontalLayout fullWidth'> {this.state.loader} </div>
        </div>
      </header>
      <section> {this.state.result} </section>
    </div>
    );
  }
}
